export default {
  above_threshold: "above threshold",
  accept: "accept",
  action_type: "action type",
  actions: "actions",
  active: "active",
  activity_type: "activity type",
  actual_completion_date_desc: "Populated when a Finance user marks the payout as completed, capturing the exact completion timestamp.",
  actual_completion_date: "actual completion date",
  add_a_comment: "add a comment",
  add_a_parameter: "add a parameter",
  add_album: "add album",
  add_all: "add all",
  add_comment: "add comment",
  add_featured_performer: "add featured performer",
  add_fee: "add fee",
  add_filter: "add filter",
  add_first_maker: "add first maker",
  add_new_parameter: "add new parameter",
  add_non_featured_performer: "add non-featured performer",
  add_ownership: "add ownership",
  add: "add",
  added_at: "added at",
  added_by: "added by",
  additional_details: "additional details",
  adjustment_reasons: "adjustment reasons",
  adjustment_scenario_0: "Scenario 0: Ad hoc/manual data fix",
  adjustment_scenario_1: "Scenario 1: Ownership change - Invalidated ownership or broadcast date changes",
  adjustment_scenario_10: "Scenario 10: Eligibility change (Yes to Unknown)",
  adjustment_scenario_13: "Scenario 13: VPP Update (increase)",
  adjustment_scenario_14: "Scenario 14: VPP Update (decrease)",
  adjustment_scenario_2: "Scenario 2: Default Ownership change (owner rights dates ended or invalidated effective date=today)",
  adjustment_scenario_3: "Scenario 3: Ownership percentage change",
  adjustment_scenario_4: "Scenario 4: Usage update",
  adjustment_scenario_7: "Scenario 7: Performer lineup change",
  adjustment_scenario_9: "Scenario 9: Eligibility change (Yes to No)",
  adjustment_transactions: "adjustment transactions",
  advanced_search: "advanced search",
  agent: "agent",
  aggregated: "aggregated",
  album_names: "album names",
  album: "album",
  albums: "albums",
  alerts: "alerts",
  aliases: "aliases",
  all_except: "all except",
  all_member_collectives: "all member collectives",
  all_tariffs: "all tariffs",
  all: "all",
  amount_gross: "gross amount",
  amount_net_delta: "Delta Net Amount",
  amount_payable: "payable amount",
  amount_raw: "raw amount",
  amount_total_delta: "Delta Total Amount",
  amount: "amount",
  answered_by: "answered by",
  any: "any",
  anyone_but_my_mc: "Anyone but my MC",
  anyone: "anyone",
  apply_moratorium: "apply moratorium",
  apply: "apply",
  apply_rounding: "apply rounding",
  approve_merge: "approve merge",
  approve_transactional_refresh: "approve transaction refresh",
  approve_transactional_removal: "approve transaction removal",
  approve: "approve",
  approved: "approved",
  artist_prefix: "artist prefix",
  artist: "artist",
  at: "at",
  auto_manually_matched: "auto manually matched",
  automatched_count: "automatched count",
  automatched: "automatched",
  automatic: "automatic",
  available_balance_maker: "available balance maker",
  available_balance_performer: "available balance performer",
  available_balance: "available balance",
  back: "back",
  backup_eligibility_scheme: "backup eligibility scheme",
  base_fees: "base fees",
  batch_id_desc: "A 6-character alphanumeric identifier that tracks transactions in progress, ensures each payout batch is unique, and records the history of removed transactions. It helps identify and manage payouts that are currently in progress.",
  batch_id: "Batch ID",
  batch: "batch",
  blocked_transactions: "blocked transactions",
  broadcast_end: "broadcast end",
  broadcast_start: "broadcast start",
  broadcaster_id: "broadcaster ID",
  broadcaster_name: "broadcaster name",
  broadcasters: "broadcasters",
  by_distribution: "by distribution",
  by_transaction: "by transaction",
  by: "by",
  calculate_vpp: "VPP calculation method",
  calculate_withholding: "calculate withtholding",
  calculation_time: "completion time",
  canada_and: "Canada and",
  canada: "canada",
  cancel_create_closeout: "Are you sure you want to cancel creating this Closeout? Any unsaved progress will be lost",
  cancel_create_fee: "Are you sure you want to cancel creating this Fee? Any unsaved progress will be lost",
  cancel_create_payout: "Are you sure you want to cancel creating this Payout? Any unsaved progress will be lost",
  cancel_create_tariff_period: "Are you sure you want to cancel creating this Tariff period? Any unsaved progress will be lost",
  cancel_edit_closeout: "Are you sure you want to cancel editing this Closeout? Any unsaved changes will be lost.",
  cancel_edit_tariff_period: "Are you sure you want to cancel you changes? Any unsaved changes will be lost.",
  cancel_payout: "cancel payout",
  cancel: "cancel",
  cancelled: "cancelled",
  candidates: "candidates",
  category: "category",
  challenge_match: "challenge match",
  challenge_owner: "challenge linked owner",
  challenge_pending: "challenge pending",
  challenge_performer: "challenge linked performer",
  challenge_source_metadata: "challenge linked metadata",
  challenge_without_recording: "create a challenge without a suggested recording",
  challenge_without_rs_id: "Challenge Without Re:Sound ID",
  challenge: "challenge",
  challenged_by: "challenged by",
  challenged_on: "challenged on",
  challenged: "challenged",
  challenges_pending: "challenges pending",
  challenges: "challenges",
  changing_college_warning: "Some selected tariff periods may not be applicable to the new type and will be ignored.",
  child_recordings_to_merge: "child recording(s) to merge",
  choose_vpp_method_help_text: "manual will allow the user to put a value on this screen, automatic will let the system calculate an automatic value based on the revenue pool",
  choose_vpp_method: "Choose the method for creating VPP",
  citizenship: "citizenship",
  claims: "claims",
  closeout_action_ready: "ready",
  closeout_action_remove: "removal",
  closeout_action_review: "review",
  closeout_completed_paid: "Completed/Paid",
  closeout_created: "closeout created",
  closeout_creation_cancelled: "Closeout creation process has been canceled. No Closeout was created",
  closeout_deleted: "closeout deleted",
  closeout_details: "closeout details",
  closeout_distributable: "distributable",
  closeout_id: "Closeout ID",
  closeout_gross: "closeout gross",
  closeout_maker_status: "maker closeout status",
  closeout_new_created: "new closeout has been created",
  closeout_not_allowed_no_open_period_end: "“The Open Period End Date” should be entered to be able to proceed when there is no open period end date entered",
  closeout_override_vpp_usage: "VPP Overrride x Usage",
  closeout_payments_calculated: "closeout payments calculated",
  closeout_performer_status: "performer closeout status",
  closeout_transactions_created: "closeout transactions created",
  closeout_updated: "closeout updated",
  closeout_vpp: "Closeout VPP",
  code: "code",
  cof: "cof",
  collapse_all: "collapse all",
  collective_society: "Collective/Society",
  collective: "collective",
  collectives: "collectives",
  college_help_text: "this will determine the type of rights holder for which the system will generate transactions",
  college_type: "college type",
  college: "college",
  comment_created_successfully: "Comment created successfully",
  comment_deleted_successfully: "Comment deleted successfully",
  comment_edited_successfully: "Comment edited successfully",
  comment_without_recording: "create a comment without a suggested recording",
  comment: "comment",
  comments: "comments",
  common: "common",
  compact_view: "compact view",
  compare_performers: "compare performers",
  complete: "complete",
  completed: "completed",
  composer: "composer",
  composers: "composers",
  confirm_the_match: "confirm the match",
  confirm: "confirm",
  confirm_create_snapshot: "Are you sure you want to create a snapshot?",
  confirm_create_transactions: "Are you sure you want to create transactions for this closeout?",
  confirm_delete_snapshot: "Are you sure you want to delete this snapshot? This action cannot be undone.",
  confirm_undo_transactions: "Are you sure you want to undo transactions for this closeout?",
  confirm_edit_closeout: "Are you sure you want to save the Closeout changes?",
  confirm_mark_as_distributable: "Are you sure you want to mark this closeout as distributable? This action cannot be undone.",
  confirm_mark_as_not_distributable: "Are you sure you want to mark this closeout as not distributable?",
  confirm_finalize_payout: "Are you sure you want to finalize this payout?",
  confirm_generate_statements: "Are you sure you want to generate statements for this payout?",
  conflict: "conflict",
  conflicted_ipn: "conflicting IPN",
  conflicted_isrc: "conflicting ISRC",
  conflicts: "conflicts",
  connect_one_time: "CONNECT One Time Payment",
  connect_open: "CONNECT Open",
  connect_reproduction: "CONNECT",
  connect_track_specific: "CONNECT Track Specific",
  consolidated_metadata: "consolidated metadata",
  consolidated_share_details: "consolidated share details",
  consolidated_usages: "consolidated usages",
  contact_admin: "please contact an administrator",
  contact_service_desk: "contact service desk",
  converted_revenue: "converted revenue",
  copy_role: "copy role",
  copy: "copy",
  copyright: "copyright",
  copyrights_and_tariffs: "copyrights and tariffs",
  copyrights: "copyrights",
  core_data: "core data",
  core_metadata: "core metadata",
  count: "count",
  countries: "countries",
  country_help_text: "country where this tariff period applies",
  country_of_fixation: "country of fixation",
  country_of_residency: "Country of Residency",
  country: "country",
  create_closeout_confirm: "Are you sure you want to create the closeout?",
  create_closeout: "create closeout",
  create_fee: "create fee",
  create_hold: "create hold",
  create_maker_closeout: "create maker closeout",
  create_merge_request: "create merge request",
  create_new_payout: "create new payout",
  create_new_sr: "Create new SR",
  create_new_tariff_period: "create new tariff period",
  create_payout: "create payout",
  create_performer_closeout: "create performer closeout",
  create_rightsholder: "Create rightsholder",
  create_role: "create user role",
  create_snapshot: "create snapshot",
  create_transactions: "create transactions",
  create_tariff_period_confirm: "Are you sure you want to create the tariff/period?",
  create_tariff_period: "create tariff period",
  create: "create",
  created_by_desc: "Identifies the user who created the payout, using the Crescendo user's first name, last name, and username for accurate tracking.",
  created_by: "created by",
  created_date: "created at",
  created_on: "created on",
  created_successfully: "created successfully",
  created: "created",
  creator: "creator",
  crescendo_help: "crescendo help",
  crescendo_id: "crescendo ID",
  crescendo_system: "Crescendo System",
  csv: "csv",
  currency: "currency",
  current_matched_recording: "current matched recording",
  current_payee: "current payee",
  current_royalties_paid: "current total royalties paid",
  current_society: "current society",
  current_usages_paid: "current total weighted usage paid",
  current: "current",
  cusma: "cusma",
  custom: "custom",
  da_agent: "DA Agent",
  da_name: "DA Name",
  da_type: "DA Type",
  database: "database",
  date_bought: "date bought",
  date_end: "date end",
  date_from: "date from",
  date_of_birth: "date of birth",
  date_of_death: "date of death",
  date_of_merge: "date of merge",
  date_range: "date range",
  date_sold: "date sold",
  date_start: "date start",
  date_to: "date to",
  date: "date",
  default_split: "default split",
  default: "default",
  delete_closeout: "delete closeout",
  delete_closeout_warning: "Are you sure you want to delete this closeout? This action cannot be undone.",
  delete_comment: "delete comment",
  delete_usage_file: "delete usage file",
  delete_hold_confirm: "are you sure you want to delete this hold?",
  delete_hold: "delete hold",
  delete_snapshot: "delete snapshot",
  delete_tariff_period: "delete tariff period",
  delete_user: "delete user",
  delete: "delete",
  deleted: "deleted",
  delta: "delta",
  deny_transaction_removal: "deny transaction removal",
  deny: "deny",
  depending_of_how_big_the_repertoire_is: "depending of how big the repertoire is, the export process can take a while",
  depending_of_how_big_the_report_is: "depending of how big the report is, the export process can take a while",
  description: "description",
  detailed_stats: "detailed statistics",
  details: "details",
  different_type: "different type",
  direct_assignor: "direct assignor",
  direct_assignors: "direct assignors",
  dis: "dis",
  discard_changes: "discard changes",
  display_all_users: "Display all Users",
  display_by_group: "Display by group",
  display_by: "display by",
  distributed: "distributed",
  distribution_date: "distribution date",
  distribution_hold: "distribution hold",
  distribution_methodology_and_eligibility: "distribution methodology and eligibility",
  distribution_methodology_help_text: "defaulted to standard usage based. This determines the internal logic the system will follow for calculating transactions, adjustments and eligibility parameters",
  distribution_methodology: "distribution methodology",
  distribution_period: "distribution period",
  distribution_status: "distribution status",
  distribution: "distribution",
  do_you_really_want_to_delete_comment: "do you really want to delete this comment",
  do_you_really_want_to_delete_tariff_period: "do you really want to delete this tariff period",
  do_you_really_want_to_delete_user: "do you really want to delete this user",
  do_you_really_want_to_invalidate_file: "do you really want to invalidate this repertoire file",
  do_you_really_want_to_invalidate_shares: "do you really want to invalidate this shares",
  do_you_really_want_to_link_this_maker: "do you really want to link this maker",
  do_you_really_want_to_link_this_performer: "do you really want to link this performer",
  do_you_really_want_to_link_this_recording: "do you really want to link this recording",
  do_you_really_want_to_unmatch_usage: "do you really want to unmatch this usage",
  do_you_want_to_launch_rematching_process: "do you want to launch the rematching process",
  domestic: "domestic",
  done: "done",
  dont_have_financial_interest: "without financial interest",
  download_template: "download template",
  download: "download",
  drill_down: "drill down",
  duplicated_conflicts_ipn: "Duplicated IPNs",
  duplicated_conflicts_isrc: "Duplicated ISRC",
  duplicated_conflicts: "Duplicated ISRCs & IPNs",
  duplicated_performer: "duplicated performer in different categories",
  dur: "dur.",
  duration: "duration",
  edit_closeout: "edit closeout",
  edit_current_payees_and_societies: "edit current payees and societies",
  edit_details: "edit details",
  edit_fee: "edit fee",
  edit_role: "edit user role",
  edit_tariff_period_confirm: "Are you sure you want to save these changes?",
  edit_tariff_period: "edit tariff period",
  edit: "edit",
  effective_calendar_end_date: "eff. calendar end",
  effective_calendar_end: "effective calendar end",
  effective_calendar_start_date: "eff. calendar start",
  effective_calendar_start: "effective calendar start",
  eligibility_conflict: "eligibility conflict",
  eligibility_conflicts: "eligibility conflicts",
  eligibility_data: "eligibility data",
  eligibility_end_date: "eligibility end date",
  eligibility_metadata: "eligibility metadata",
  eligibility_parameter: "eligibility parameter",
  eligibility_scheme: "eligibility scheme",
  eligibility_start_date: "eligibility start date",
  eligibility: "eligibility",
  eligible: "eligible",
  email: "email",
  end_date_should_be_greater_or_equal: "End date should be greater or equal to start date",
  end_date: "end date",
  endpoint: "endpoint",
  enter_name_or_description: "enter a name or description",
  enter_tariff: "enter the tariff for this Tariff Period",
  error_occurred: "an error occurred, please contact an administrator",
  error_type: "error type",
  error_updating_user: "error updating user",
  error: "error",
  errors: "errors",
  estimated_completion_date: "estimated completion date",
  estimated_track_value: "estimated track value",
  excel: "excel",
  except_placeholder: "Choose the options you want to exclude",
  except: "except",
  exchange_rate: "exchange rate",
  execute_transaction_refreshes: "You are about to execute all pending transaction refresh requests in the queue. This action cannot be undone. Do you want to proceed?",
  execute_transaction_removals: "You are about to execute all approved transaction removal requests in the queue. This action cannot be undone. Do you want to proceed?",
  execute: "execute",
  execution_date: "execution date",
  expand_all_sources: "expand all sources",
  expand_all: "expand all",
  export_ownership_conflicts: "export ownership conflicts",
  export_payouts_list: "export payouts list",
  export_repertoire_for_ss: "export repertoire for sister society",
  export_repertoire: "export repertoire",
  export_status: "export status",
  export_tariff_period_list: "export tariff period list",
  export_transactions_list: "export transactions list",
  export_snapshot: "export snapshot",
  export_unclaimed_recordings: "export unclaimed recodings",
  export_usages: "export usages",
  export: "export",
  exported_file_will_contain_unique_recordings: "exported file will contain unique recordings, and will have less results than shown on screen when multiple consolidated usages are matched to the same recording.",
  external: "external",
  failed: "failed",
  feature: "feature",
  featured_and_non_featured: "featured and non-featured",
  featured_count: "Featured Count",
  featured: "featured",
  fee_creation_cancelled: "Fee creation process has been canceled. No Fee was created",
  fees: "fees",
  female: "female",
  field: "field",
  file_upload_date: "file upload date",
  file: "file",
  filename: "filename",
  files_exceed_the_rows_limitation: "files exceed the 200,000 rows limitation of the Excel file format",
  fill_in_the_missing_fields: "please fill in all the required information before submitting",
  filter_by_action: "filter by action",
  filter_by_collective_society: "Filter by Collective/Society",
  filter_by_role: "Filter by Role",
  filter_by_sister_society: "Filter by Collective/Society",
  filter_by_state: "filter by state",
  filters: "filters",
  filters_not_applicable_in_aggregation: "The following filters are not available in the selected aggregation and will be removed:",
  filters_not_applicable_title: "Filters not applicable",
  financial_actions: "financial actions",
  first_maker_nationality: "first maker nationality",
  first_maker: "first maker",
  first_makers_nationalities: "first makers nationalities",
  first_makers: "first makers",
  fixation_country: "fixation country",
  fixation_year: "fixation year",
  fm_nationality: "FM Nationality",
  finalization_in_progress: "finalization in progress",
  finalized: "finalized",
  finalize_payout: "finalize payout",
  fmn: "fmn",
  for: "for",
  form_contains_errors: "form contains errors",
  format_file: "format file",
  from_maker_source: "Data from maker source or migrated from OPUS",
  from_role: "from role",
  gender: "gender",
  general_details: "general details",
  general_rejection: "General Rejection",
  general: "general",
  generate_report: "generate report",
  generate_statements: "generate statements",
  genre_conflict_pending: "genre conflict pending",
  genre_conflict: "Genre Conflict",
  genre_type: "Genre Type",
  genre: "genre",
  go_back: "go back",
  go_to: "go to",
  gross_amount: "gross amount",
  gross: "gross",
  has_an_agent: "has an agent",
  has_candidates: "has candidates",
  has_financial_interest: "has financial interest",
  has_locked_data: "has locked data",
  has_mandate_locked: "has mandate locked",
  has_owners: "has owners",
  has_performers: "has performers",
  has_transaction: "has transaction",
  have_financial_interest: "with financial interest",
  help_guide: "help guide",
  hide_invalidated: "hide invalidated",
  hide_without_mandates: "hide without mandates",
  highlight_differences: "highlight differences",
  history: "history",
  hold_help_text: "whether any of the colleges (or both) should have their payments held currently",
  hold_reason: "hold reason",
  hold: "hold",
  hotkeys: "hotkeys",
  iconography: "iconography",
  id_proprietary_id: "ID / Proprietary ID",
  id_resound_id: "ID / Resound ID",
  id: "ID",
  import: "import",
  in_progress: "in progress",
  in_review: "in review",
  in: "in",
  inactive: "inactive",
  include_closeouts: "include closeouts",
  include_placeholder: "Choose specific options you want to include",
  include_specific: "include specific",
  incompatible_types_to_merge: "selected recording has incompatible types to merge",
  inconsistent_genres: "different genres provided in different sources",
  inconsistent_number_of_performers: "inconsistent number of performers provided in different sources",
  indirect_mc: "Indirect MC",
  information: "information",
  informational: "informational",
  ingested_count: "ingested count",
  ingested_on: "ingested on",
  ingested: "ingested",
  ingestion_error_message: "file ingestion encountered an error:",
  ingestion_error: "ingestion error",
  ingestion_stats: "ingestion stats",
  initial_status: "Initial status",
  inline_error: "error occurred",
  inline_success: "successfully matched",
  input: "input",
  internal_or_external: "internal or external",
  internal_payout_id: "Internal Payout ID",
  internal: "internal",
  international_incoming_fees: "Incoming international fees",
  international_incoming: "international incoming",
  international: "international",
  invalidate_file: "invalidate file",
  invalidate_shares: "invalidate shares",
  invalidate: "invalidate",
  invalidated: "invalidated",
  invalidation_effective_date: "invalidation effective date",
  invoice_number: "invoice number",
  invoice: "invoice",
  ipn: "IPN",
  is_junk: "is junk",
  is_not_junk: "is not junk",
  isrc: "ISRC",
  issues_found_in_section: "issues found. Please review and correct the errors.",
  item: "item",
  items_per_page: "items per page",
  items: "items",
  junk_history: "junk history",
  junk_status: "junk status",
  junk: "junk",
  junked_usage: "junked usage",
  keep: "keep",
  landed: "landed",
  landing_recording: "landing recording",
  last_calculation_distribution: "last calculation",
  last_calculation: "last calculation run",
  last_updated_by: "last updated by",
  latest_review_date: "latest review date",
  latest_review: "latest review",
  launch_rematch_process: "landed",
  lead_role: "team lead user role",
  level: "level",
  licensee_name: "licensee name",
  lineup_adjustments: "lineup adjustments",
  lineup_conflict_playcount_percentage_delta: "Lineup Conflict Playcount delta %",
  lineup_conflict_playcount_percentage: "Lineup Conflict Playcount %",
  lineup_conflict_playcount: "Lineup Conflict Playcount",
  lineup_conflict_recordings_percentage_delta: "Lineup Conflict Recordings delta %",
  lineup_conflict_recordings_percentage: "Lineup Conflict Recordings %",
  lineup_conflict_recordings: "Lineup Conflict Recordings",
  lineup_conflict_title: "Lineup Conflict",
  lineup_conflict: "line-up conflict",
  link_maker: "link maker",
  link_performer: "link performer",
  link_recording: "link recording",
  linked_with_master: "linked with the master",
  linked: "linked",
  load_all_transactions: "Load All Transactions",
  load_transactions: "load transactions",
  loading_tariff_periods: "Loading Tariff Periods. This operation may take a while.",
  loading_transactions: "loading transactions",
  lock_featured: "lock featured",
  lock_non_featured: "lock non-featured",
  locked_fields: "locked fields",
  locks: "locks",
  log_format: "log format",
  loss_of_mandate:"Loss of Mandate",
  main_details: "main details",
  main_performers: "main performers",
  make_comment: "make a comment",
  maker_and_performer: "maker and performer",
  maker_manual_matching: "maker manual matching",
  maker_matching_challenge: "maker matching challenge",
  maker_name: "maker name",
  maker_open_period_end_date_help_text: "open period end date will be set automatically to 4 years after the end date of the tariff period",
  maker_status: "maker status",
  maker_vpp: "Maker VPP",
  maker: "maker",
  makers: "makers",
  male: "male",
  manage_maker_closeout: "manage maker closeout",
  manage_performer_closeout: "manage performer closeout",
  managed_by: "managed by",
  mandate_conflict_pending: "mandate conflict pending",
  mandate_conflict_playcount_percentage_delta: "Mandate Conflict Playcount delta %",
  mandate_conflict_playcount_percentage: "Mandate Conflict Playcount %",
  mandate_conflict_playcount: "Mandate Conflict Playcount",
  mandate_conflict_recordings_percentage_delta: "Mandate Conflict Recordings delta %",
  mandate_conflict_recordings_percentage: "Mandate Conflict Recordings %",
  mandate_conflict_recordings: "Mandate Conflict Recordings",
  mandate_conflict: "mandate conflict",
  mandate_file: "mandate file",
  mandate: "mandate",
  mandates: "mandates",
  manual_matching: "manual matching",
  manual_submissions: "manual submissions",
  manual: "manual",
  manually_created: "manually created",
  manually_linked: "manually linked",
  manually_matched_count: "manually matched count",
  manually_matched: "manually matched",
  mark_all_as_read: "mark all as read",
  mark_as_distributable: "mark as distributable",
  mark_as_not_distributable: "mark as not distributable",
  mark_as_junk: "mark as junk",
  mark_as_not_junk: "mark as not junk",
  mark_as_read: "mark as read",
  mark_as: "mark as",
  marked_as: "marked as",
  match_date: "match date",
  match_sr: "Match Recording",
  match: "Match",
  matched_by: "matched by",
  matched_maker: "Matched - Maker",
  matched_on: "matched on",
  matched_performer: "Matched - Performer",
  matched_playcount_delta_percent: "matched playcount delta %",
  matched_playcount_delta: "Matched Playcount delta",
  matched_playcount_percent: "matched playcount %",
  matched_playcount_percentage_delta: "Matched Playcount delta %",
  matched_playcount_percentage: "Matched Playcount %",
  matched_playcount: "matched playcount",
  matched_status: "matched status",
  matched_to: "matched to",
  matched: "matched",
  matching_conflict_pending: "matching conflict pending",
  matching_conflicts_down_key: "Select next conflict",
  matching_conflicts_question_key: "Show this dialog",
  matching_conflicts_r_key: "Refresh data on the page",
  matching_conflicts_up_key: "Select previous conflict",
  matching_conflicts: "matching conflicts",
  matching_date: "matching date",
  matching_stats_export: "matching statistics export",
  matching_stats: "matching Stats",
  matching_type: "matching type",
  mc_source: "member collective source",
  mc: "member collective",
  member_collective: "member collective",
  member_collectives: "member collectives",
  member_name: "member name",
  merge_makers: "merge makers",
  merge_performers: "merge performers",
  merge_recordings: "merge recordings",
  merge_request_created: "merge request created successfully",
  merge_requests: "merge requests",
  merge: "merge",
  merged_makers: "merged makers",
  merged_performers: "merged performers",
  merged_recordings: "merged recordings",
  merged_srs: "merged recordings",
  min_threshold: "minimum threshold",
  missing_featured_count: "missing featured count",
  missing_mandate: "missing mandate",
  missing_non_featured_count: "missing non featured count",
  modify_scope: "modify scope",
  modify_shares: "modify shares",
  moratorium_applied_success: "Moratorium on the colleges: {colleges} for the {distribution} tariff period has been successfully placed.",
  moratorium_apply_text: "You are about to place a moratorium on the {distribution} tariff period. Please select the type of college from the dropdown before proceeding.",
  moratorium_help_text: "Moratorium threshold is the minimum amount that will be paid to the colleges in case of a moratorium. If the total amount to be paid to the colleges is less than this value, the system will pay the moratorium value instead.",
  moratorium_minimum: "moratorium minimum",
  moratorium_remove_text: "You are about to remove the moratorium for the {distribution} tariff period. Please select the type of college from the dropdown before proceeding.",
  moratorium_removed_success: "Moratorium on the colleges: {colleges} for the {distribution} tariff period has been successfully removed.",
  moratorium_status: "moratorium status",
  moratorium: "moratorium",
  more_performers_than_specified: "reconciling results in more performers in category than specified by the sources",
  more_resources: "more resources",
  multi_sorting_help_text: "Use Shift key to select multiple columns for sorting",
  music_master: "music master",
  music_video: "music video",
  must_be_a_decimal: "this field must be a decimal number",
  must_be_a_year: "the value must be a valid year",
  must_be_before_target: "this field must be after {_target_}",
  must_be_duration: "invalid duration (format mm:ss)",
  must_be_isrc: "Invalid ISRC (format CAK401400212)",
  must_be_less_than: "this field must be less than {max}",
  must_be_more_than: "This field must be more than {min}",
  must_be_positive: "this field must be a positive number",
  must_have_at_most_8_decimal_places: "this field must have at most 8 decimal places",
  my_matches: "my matches",
  my_mc: "My MC",
  name: "name",
  nationalities: "nationalities",
  nationality: "nationality",
  net_amount: "net amount",
  net_available_for_closeout: "net available for closeout",
  net: "net",
  new_data: "new data",
  new_payees_and_societies: "new payee(s) and society(ies)",
  new_tariff_period: "new tariff/period",
  next_calculation: "next calculation run",
  next: "next",
  no_access_featured: "You have no permission to review this recording's featured lineup",
  no_access_non_featured: "You have no permission to review this recording's non-featured lineup",
  no_access: "no access",
  no_changes_were_made: "No changes were made",
  no_continue_editing: "No, continue editing",
  no_filter: "no filter",
  no_genre_conflict: "No Genre Conflict",
  no_hold: "No Hold",
  no_lineup_conflict_title: "No Lineup Conflict",
  no_mandate_conflict: "No Mandate Conflict",
  no_mandates: "no active mandates",
  no_moratorium: "no moratorium",
  no_ownership_conflict: "No Ownership Conflict",
  no_performers_featured: "No featured Performers for this Recording yet",
  no_performers_non_featured: "No non-featured Performers for this Recording yet",
  no_permissions_ownership: "You have no permission to review this recording's ownership information",
  no_proxy: "No proxy",
  no_recording_balance_exceeded: "recording balance not exceeded",
  no_representation: "No representation",
  no_rightsholder_found: "No rights holder found",
  no_stations: "No stations for this Broadcaster yet",
  no: "no",
  non_eligible_playcount_percentage_delta: "Non-Eligible Playcount delta %",
  non_eligible_playcount_percentage: "Non-Eligible Playcount %",
  non_eligible_playcount: "Non-Eligible Playcount",
  non_eligible_recordings_percentage_delta: "Non Eligible Recordings delta %",
  non_eligible_recordings_percentage: "Non Eligible Recordings %",
  non_eligible_recordings: "Non Eligible Recordings",
  non_feature: "non-feature",
  non_featured_count: "Non-Featured Count",
  non_featured: "non-featured",
  none: "none",
  not_enough_number_of_performers: "not enough number of performers",
  not_finished: "not finished",
  not_junk: "not junk",
  not_started: "not started",
  notes_help_text: "use this field for writing any notes for users to read",
  notes: "notes",
  notification_center: "notification center",
  nr: "nr",
  number_of_performers: "# of perfs",
  of: "of",
  official: "official",
  old_data: "old data",
  on_hold: "On Hold",
  on: "on",
  only_affected_rights_holders: "only affected rights holders",
  open_in_new_tab: "open in new tab",
  open_period_end_date: "open period end date",
  open_period_start_date_help_text: "open period start date will be set to the 1st day of the month following the end date of the tariff period",
  open_period_start_date: "open period start date",
  open_period: "open period",
  original_artist: "original artist",
  original_currency: "original currency",
  original_royalties_paid: "original royalties paid",
  original_title: "original title",
  original_total_royalties_paid: "Original total royalties paid",
  original_total_weighted_usage_paid: "Original total weighted usage paid",
  original_usages_paid: "Original total weighted usage paid",
  other: "other",
  owners: "owners",
  ownership_adjustments: "ownership adjustments",
  ownership_conflict_playcount_percentage_delta: "Ownership Conflict Playcount delta %",
  ownership_conflict_playcount_percentage: "Ownership Conflict Playcount %",
  ownership_conflict_playcount: "Ownership Conflict Playcount",
  ownership_conflict_recordings_percentage_delta: "Ownership Conflict Recordings delta %",
  ownership_conflict_recordings_percentage: "Ownership Conflict Recordings %",
  ownership_conflict_recordings: "Ownership Conflict Recordings",
  ownership_conflict: "Ownership Conflict",
  ownership_conflicts: "ownership conflicts",
  ownership: "ownership",
  page: "page",
  paid_amount_maker: "paid amount maker",
  paid_amount_performer: "paid amount performer",
  paid_date: "paid date",
  paid_net_amount: "net paid amount",
  paid_payee: "paid payee",
  paid_society: "paid society",
  paid_status: "paid status",
  paid: "Paid",
  parameters: "parameters",
  parent_recording: "parent recording",
  parties: "parties",
  payability_checks: "pay-ability checks",
  payable_amount_maker: "payable amount maker",
  payable_amount_performer: "payable amount performer",
  payable_amount: "payable amount",
  payable_playcount_percentage_delta: "Payable Playcount delta %",
  payable_playcount_percentage: "Payable Playcount %",
  payable_playcount: "Payable Playcount",
  payable_raw_amount: "payable raw amount",
  payable_recordings_delta_percent: "payable recordings delta %",
  payable_recordings_percent: "payable recordings %",
  payable_recordings: "payable recordings",
  payable: "payable",
  payee_id: "Payee ID",
  payee_name: "Payee Name",
  payee_tariff: "Payee + Tariff Period",
  payee_type: "payee type",
  payee: "payee",
  payees: "payees",
  payment_due: "payment due",
  payment_history_snapshot: "Payment History Snapshot",
  payment_hold: "payment hold",
  payment_statements: "payment statements",
  payment_status: "Payment Status",
  payment_uploads: "payment uploads",
  payments: "payments",
  payout_creation_cancelled: "payout creation cancelled",
  payout_finalization_started: "payout finalization started",
  payout_failed: "Payout failed. Please contact administrator.",
  payout_id_desc: "Assigned to transactions upon payout completion and displayed on paid transactions. IDs increment sequentially (e.g., 1, 2, 3). If a payout in progress is canceled, the same ID will be reassigned to the next payout.",
  payout_invalid_status_for_statements: "This payout is no longer in a valid status for statement generation. Refresh the page and try again.",
  payout_ID: "Payout ID",
  payout_id: "Payout ID#",
  payout: "payout",
  payouts: "payouts",
  pc_maker: "PC Maker",
  pc_performer: "PC Performer",
  pending_for_validation: "pending for validation",
  pending_maker_matching: "Pending Maker Match",
  pending_matches: "Pending matches",
  pending_performer_matching: "Pending Performer Match",
  pending_queue: "pending queue",
  pending_recalculate: "pending recalculate",
  pending_representation_is_same: "new representation should be different from previous one",
  pending_user_actions: "pending user actions",
  pending: "pending",
  percentage: "percentage",
  percent_paid: "% paid",
  performer_id: "performer id",
  performer_in_both_categories: "same performer participates in both categories in sources",
  performer_lineups: "performer lineups",
  performer_manual_matching: "performer manual matching",
  performer_matching_challenge: "performer matching challenge",
  performer_name: "performer name",
  performer_open_period_end_date_help_text: "open period end date will be set to 6 years after the end date of the tariff period",
  performer_status: "performer status",
  performer_vpp: "Performer VPP",
  performer: "performer",
  performers_comparison: "performers comparison",
  performers_linked: "performers linked successfully",
  performers: "performers",
  period_description: "period descr.",
  period_end_date_help_text: "end date should be later than the value entered for the period start date",
  period_end_date: "period end date",
  period_end: "period end",
  period_start_date_help_text: "date should be later than the previous tariff period's end date for the same tariff and should not overlap with the start and end date range of any other tariff periods for the same tariff",
  period_start_date: "period start date",
  period_start: "period start",
  period: "period",
  place_moratorium: "Place moratorium",
  placeholder: "placeholder",
  playcount: "playcount",
  playcounts_eligible: "eligible playcounts",
  playcounts_ineligible_help_text: "percentage of ineligible playcounts to be used for automatic VPP calculation",
  playcounts_ineligible_percentage_display: "Ineligible playcounts used of VPP calculation (%)",
  playcounts_ineligible_percentage_short: "Ineligible playcounts (%)",
  playcounts_ineligible_short: "Ineligible playcounts",
  playcounts_ineligible: "ineligible playcounts",
  playcounts_unmatched_help_text: "percentage of unmatched playcounts to be used for automatic VPP calculation",
  playcounts_unmatched_percentage_display: "Unmatched playcounts used of VPP calculation (%)",
  playcounts_unmatched_percentage_short: "Unmatched playcounts (%)",
  playcounts_unmatched_short: "Unmatched playcounts",
  playcounts_unmatched: "unmatched playcounts",
  playcounts_used_display: "Total number of playcounts used for calculation",
  playcounts_used_short: "Used playcounts",
  plays: "plays",
  please_pick_a_parent_maker: "please pick a parent maker",
  please_pick_a_parent_performer: "please pick a parent performer",
  please_pick_a_parent_recording: "please pick a parent recording",
  preview_flag: "preview flag",
  preview: "preview",
  previous: "previous",
  primary_eligibility_scheme_help_text: "eligibility schemes define the rules to follow to determine if a transaction is eligible for payment or not",
  primary_eligibility_scheme: "primary eligibility scheme",
  process_already_running: "process is already running",
  processing_may_take_some_time: "processing may take some time",
  processing: "processing",
  promoted: "promoted",
  proprietary_id: "Proprietary ID",
  proprietary_ids: "Proprietary IDs",
  province_station_count: "province station count",
  province: "province",
  provincial_population: "provincial population",
  proxy_period_end_date: "proxy period end date",
  proxy_period_period_help_text: "proxy tariff start and end dates will determine the date range for usages that will apply to this tariff period",
  proxy_period_start_date: "proxy period start date",
  proxy_tariff_help_text: "if a proxy tariff is chosen, its related usages will be used for the transactions calculation",
  proxy_tariff_value_help_text: "chose the proxy tariff for this Tariff Period",
  proxy_tariff: "proxy tariff",
  proxy: "proxy",
  raised_by_member_collective: "raised_by_member_collective",
  raised_by: "raised by",
  range_filter_empty_bound_description: "*leave empty to exclude",
  rank: "rank",
  rate: "rate",
  raw: "raw",
  ready_for_sync: "ready for synchronization",
  ready_for_transaction: "ready for transaction",
  ready: "ready",
  real_action: "real.",
  real_refunded_for_sync: "recording is marked as refunded for sync",
  real_released_for_sync: "recording is marked as released for sync",
  real_sync_status: "sync.",
  real: "real",
  reason: "reason",
  rec: "rec",
  recalculate_snapshot: "recalculate snapshot",
  reconciled_lineup: "reconciled lineup",
  reconciliation_error: "reconciliation error",
  reconciliation_pending: "reconciliation pending",
  recording_albums: "recording albums",
  recording_artist: "recording artist",
  recording_balance_exceeded: "recording balance exceeded",
  recording_balance: "recording balance",
  recording_challenges_actions: "recording challenges",
  recording_eligibility_conflict_resolved: "recording eligibility conflict resolved",
  recording_id: "Recording ID",
  recording_isrc: "Recording ISRC",
  recording_matching_challenge: "recording matching challenge",
  recording_matching_stats: "Rec. Match. Stats",
  recording_matching_status: "recording matching status",
  recording_title: "recording title",
  recording_type: "recording type",
  recording: "recording",
  recordings_count: "recordings count",
  recordings_in_other_merge_requests: "highlighted recordings are already part of other merge request(s)",
  recordings_linked: "recordings merged successfully",
  recordings_merge_request_rejected: "merge rejected successfully",
  recordings_reconciliation_started: "recordings update has been started.",
  recordings: "recordings",
  reference_information: "reference information",
  refresh_failed: "refresh failed",
  refresh_jobs_fail: "failed to execute pending transaction refresh requests. Please contact administrator or try again.",
  refresh_jobs_success: "all pending transaction refresh requests have been successfully executed.",
  refresh_progress: "refresh in progress",
  refresh_queued:"refresh queued",
  refresh_representation: "refresh representation",
  refresh_request_fail: "failed to create refresh request.",
  refresh_request_success: "refresh request has been successfully submitted.",
  refresh_request: "refresh request",
  refresh: "refresh",
  refreshed: "refreshed",
  refund_payment: "refund payment",
  refund_undistributed: "refund undistributed",
  reject_merge: "reject merge",
  release_payment: "release payment",
  release_year: "release year",
  released: "released",
  releases: "releases",
  remaining_revenue_override: "remaining revenue override",
  remaining_revenue: "remaining revenue",
  remaining_transactions: "remaining transactions",
  rematch_usages: "rematch usages",
  rematching_launched: "rematch launched",
  removal_denied: "Removal denied",
  removal_jobs_fail: "failed to execute pending transaction removal requests. Please contact administrator or try again.",
  removal_jobs_success: "all pending transaction removal requests have been successfully executed.",
  removal_progress: "removal in progress",
  removal_queued: "Removal queued",
  removal_request_fail: "failed to remove transaction. Please contact administrator or try again.",
  removal_request_success: "Removal request has been successfully submitted and will be reviewed by a member of the Re:Sound team shortly.",
  removal_requested: "Removal requested",
  removal_requests: "Removal requests",
  removal: "removal",
  remove_fee: "remove fee",
  remove_moratorium: "Remove moratorium",
  remove_transaction: "remove transaction",
  remove: "remove",
  removed: "removed",
  removing_moratorium: "Removing moratorium",
  rep_track: "RepTrack",
  repertoire_actions: "repertoire actions",
  repertoire_errors: "repertoire errors",
  repertoire_file_invalidated: "repertoire file invalidated successfully",
  repertoire_file: "repertoire file",
  repertoire_matching: "repertoire matching",
  repertoire: "repertoire",
  report_generated: "report generated",
  report_requested: "report requested",
  report: "report",
  reporting: "reporting",
  representation_changed: "representation changed",
  representation_unchanged: "representation unchanged",
  representative: "representative",
  request_date: "request date",
  requested_on: "requested on",
  requester: "requester",
  requests: "requests",
  reserve_help_text: "amount to subtract from the available pool as a reserve for this specific college",
  reserve: "reserve",
  reserve2_enable: "enable reserve 2",
  reserve2: "reserve 2",
  reset_changes: "reset last action",
  reset_to_default: "reset to default",
  reset: "reset",
  resolve: "resolve",
  resolved_matches: "Resolved matches",
  resolved_on: "resolved on",
  resolved: "resolved",
  resound_id: "Resound ID",
  result: "result",
  revenue_currency_help_text: "Defaulted to CAD, this determines which currency the system uses to generate the transactions",
  revenue_currency: "revenue currency",
  revenue_help_text: "enter the collected revenue as a currency value",
  revenue_source_country: "revenue source country",
  revenue_total: "revenue total",
  revenue: "revenue",
  review_date: "review date",
  review_history: "review history",
  reviewed_by: "Reviewed by",
  reviewed_count: "reviewed count",
  reviewed: "reviewed",
  reviewer: "reviewer",
  rh_id: "rh. id",
  rh_name: "RH. name",
  rig: "rig",
  rights_holder_id: "Rights Holder ID",
  rights_holder_name: "Rights Holder Name",
  rights_holder_proprietary_ids: "Rights Holder Proprietary IDs",
  rights_holder_recording: "Rights holder + Recording",
  rights_holder_tariff_period: "Rights holder + Tariff Period",
  rights_holder_tariff_recording: "Rights holder + Tariff Period + Recording",
  rights_holder_title: "Rights Holder",
  rights_holder_type: "rightsholder type",
  rights_holder: "rightsholder",
  rights_holders: "Rights Holders",
  rightsholder_challenges: "rightsholder challenges",
  rightsholder_id: "rightsholder id",
  rightsholder_matching_stats: "Righ. Match. Stats",
  rightsholder_matching_status: "rightsholder matching status",
  rightsholder_name: "rightsholder name",
  rightsholder_proprietary_id: "rightsholder proprietary id",
  rightsholder_type: "rightsholder type",
  rightsholder: "rightsholder",
  rightsholders_actions: "rightsholders actions",
  rightsholders_linked: "rightsholders linked successfully",
  rightsholders: "rightsholders",
  role: "role",
  royalties_paid: "royalties paid",
  royalties: "royalties",
  royalty_details: "royalty details",
  salesforce_id: "Salesforce ID",
  same_type: "same type",
  save_back: "save & back",
  save_changes: "save changes",
  save: "save",
  saved_as_draft: "saved as draft",
  saved_changes_solved: "changes were successfully saved and the conflict was solved",
  saved_changes: "changes were successfully saved",
  scope: "scope",
  scoped: "scope set",
  search_agent: "search agent",
  search_all_recordings: "search all recordings",
  search_for_a_maker: "search for a maker",
  search_maker: "search maker",
  search_other_candidates: "search other candidates",
  search_performer: "search performer",
  search_recording: "search recording",
  search_rightsholder: "search rightsholder",
  search_suggested_match_id: "Search Suggested Re:Sound ID",
  search_tariff_period: "search tariff period",
  search_user: "search user",
  search: "search",
  searched_recordings: "searched recordings",
  secondary_eligibility_scheme_help_text: "if primary eligibility scheme is found not eligible, the system will use this secondary eligibility scheme to define if the transaction is eligible or not",
  secondary_eligibility_scheme: "secondary eligibility scheme",
  see_sr_history: "See SR's whole history",
  select_all_page: "select all in this page",
  select_all: "select all",
  select_copyrights: "select copyrights",
  select_countries: "select countries",
  select_country_of_fixation: "select country of fixation",
  select_date_range: "select date range",
  select_first_maker_nationalities: "select first maker nationalities",
  select_first_makers: "select first makers",
  select_mc: "select mc",
  select_member_collectives: "select member collectives",
  select_source_metadata: "select source metadata",
  select_stations: "select stations",
  select_status: "select status",
  select_tariffs: "select tariffs",
  selector: "selector",
  sent_for_sync: "Data was sent for sync",
  service_fees: "service fees",
  set_scope: "set scope",
  sf: "sf",
  share_delta: "Delta Share",
  share_payee: "Payee Share",
  share: "share",
  shared_repertoire_area: "shared repertoire area",
  shares_invalidated: "shares invalidated successfully",
  shares_modified: "shares modified successfully",
  show_all_types: "show all types",
  show_available_unmatch: "show available for unmatch only",
  show_by_file: "show by file",
  show_closed_usages: "show from closed periods",
  show_done: "show done",
  show_from_secondary_sources_help: "show performer conflicts from non-performer sources and maker conflicts from non-maker sources",
  show_from_secondary_sources: "show from secondary sources",
  show_history: "Show history",
  show_landing_data: "Show landing data",
  show_only_source_metadata_in_conflict: "show only source metadata in conflict",
  show_parent_data: "show parent recording data",
  show_read_notifications: "Show read notifications",
  show_rep_tracks: "Show RepTracks",
  show_resolved: "show resolved",
  show_same_type: "same type recordings",
  show_source_metadata: "show source metadata",
  show_system_challenges: "show system challenges",
  show_vpp_history: "Show VPP History",
  showing: "showing",
  simple_repertoire_export: "export filtered recordings",
  sister_society: "sister society",
  snapshot_changes_summary: "{count} snapshot lines will be modified",
  snapshot_changes_saved: "snapshot changes saved",
  snapshot_created: "snapshot created",
  snapshot_calculation_failed: "Snapshot calculation failed. Please try again or contact support if the problem persists.",
  snapshot_calculation_running: "Snapshot calculation is running. Please wait.",
  snapshot_comment_will_be_updated: "{count} comment will be updated",
  snapshot_deleted: "snapshot deleted",
  snapshot_in_review: "Some snapshot lines are still in review",
  snapshot_must_be_created: "Transactions can be created only after snapshot was created",
  snapshot_refresh_required: "VPP update must be applied, run snapshot refresh",
  snapshot_refresh_started: "snapshot refresh started",
  snapshot_representation_will_be_updated: "{count} current payee(s) and current society(ies) will be modified",
  snapshot_status_will_be_updated: "{count} will be updated to {status}",
  snapshot_taken: "snapshot taken",
  societies: "societies",
  society: "society",
  solve: "solve",
  sound_exchange: "sound exchange",
  sound_recording: "sound recording",
  source_file: "source file",
  source_isrc: "Source ISRC",
  source_metadata: "source metadata",
  source_name: "source name",
  source_proprietary_id: "Source Proprietary ID",
  source: "source",
  sources: "sources",
  split: "split %",
  split_must_total_100: "Split percentages must add up to 100%",
  sr_history: "SR history",
  sr_id: "SR ID",
  sra: "sra",
  standard_usage_based: "standard usage based",
  standard: "standard",
  start_date: "start date",
  statement_generated: "statement generated",
  statement_id: "Statement ID",
  statement_not_available: "statement not available yet",
  statement_period: "stat. period",
  statement_type: "statement type",
  statements_generation_started: "Statements generation started. This may take a few minutes.",
  station_name: "station name",
  station: "station",
  stations: "stations",
  statistics: "statistics",
  status: "status",
  sub_genre: "Sub genre",
  success: "success",
  suggested_match_id: "Suggested Re:Sound ID",
  suggested_recordings: "suggested recordings",
  swap: "swap",
  sync_payments: "sync payments",
  system_users: "system users",
  tariff_code: "tariff code",
  tariff_period_created: "new tariff/period has been created",
  tariff_period_creation_cancelled: "Tariff period creation process has been canceled. No Tariff period was created",
  tariff_period_edit_cancelled: "Changes have been successfully discarded.",
  tariff_period_end: "tariff period end",
  tariff_period_id: "Tariff Period ID",
  tariff_period_start: "tariff period start",
  tariff_period_title: "Tariff Period",
  tariff_period_year: "tariff period year",
  tariff_period: "tariff period",
  tariff_periods: "tariff periods",
  tariff: "tariff",
  tariffs_in_scope_desc: "Indicates the number of tariff periods included in the payout scope. Updates automatically based on the tariff periods selected during scope definition.",
  tariffs_in_scope: "tariff periods in scope",
  tariffs_included_desc: "Tariffs included in the payout, determined based on the selected tariff periods.",
  tariffs_included: "tariffs included in the payout",
  tariffs: "tariffs",
  technical_documentation: "technical documentation",
  territories: "territories",
  territory_of_incoming_royalties: "territory of incoming royalties",
  territory: "territory",
  the_information_is_too_different_merge_request: "The information is too different. Please check this box to force the merge request.",
  the_information_is_too_different_merge: "The information is too different. Please check this box to force the merge.",
  this_field_is_required: "this field is required",
  this_field_must_be_a_valid_email: "this field must be a valid email",
  this_fields_confirmation_does_not_match: "this fields confirmation does not match",
  this_maker_is_not_in_the_candidates_list: "this maker is not in the candidates list",
  this_performer_is_not_in_the_candidates_list: "this performer is not in the candidates list",
  this_recording_is_not_in_the_candidates_list: "this recording is not in the candidates list",
  threshold_reached: "threshold reached",
  threshold: "threshold",
  title: "title",
  today: "today",
  total_closeout_revenue: "total closeout revenue",
  total_payments: "total payments",
  total_playcount_delta: "Playcount Delta",
  total_playcount: "Total Playcount",
  total_recordings: "total recordings",
  total_royalties_paid: "total royalties paid",
  total_transactions: "total transactions",
  total_unique: "total unique",
  total_usage_for_vpp: "Total usage for VPP",
  total_usage_paid: "total usage paid",
  total: "total",
  transaction_batch_id: "Transaction batch ID#",
  transaction_calculation_date: "Transaction Calc. date",
  transaction_calculation_timestamp: "Transaction Calculation Timestamp",
  transaction_id: "Transaction ID",
  transaction_payout: "Transactions & Payouts",
  transactions_count: "# of Transactions",
  transactions_creation_started: "transactions creation started",
  transactions_removed: "Transactions removed",
  transactions_undo_started: "transactions undo started",
  transactions_select_filter_text: "No transactions loaded. Click the filter icon in the top right of your screen to apply filters and start viewing your data.",
  transactions: "transactions",
  trigger_transactions: "trigger transactions calculation",
  triggered_transactions_confirmation_rh: "Are you sure you want to trigger the transactions calculation for all tariff periods related to this rights holder?",
  triggered_transactions_confirmation_sr: "Are you sure you want to trigger the transactions calculation for all tariff periods related to this recording?",
  triggered_transactions_correctly: "Transactions calculation was triggered correctly. The system will show updated transactions once calculation process has finished",
  triggered_transactions: "triggered transactions",
  type_to_search: "start typing to see options",
  type_of_fee: "type of fee",
  type_of_right: "type of right",
  type: "type",
  unclaimed_for: "unclaimed for",
  undo_create: "undo create",
  undo_match: "undo match",
  undo_transactions: "undo transactions",
  undone_error: "Couldn't undo action",
  undone_success: "Action undone successfully",
  unidentified_conflict: "Unidentified Conflict",
  unidentified_mandate_conflict: "Unidentified Mandate Conflict",
  unique_count: "unique count",
  unknown: "unknown",
  unlink_create_rightsholder: "Unlink and create a new rightsholder",
  unlink_create_sr: "Unlink and create a new SR",
  unlinked: "unlinked",
  unmatch_usage: "Unmatch this usage",
  unmatched_count: "unmatched count",
  unmatched: "unmatched",
  unpaid_below_threshold:"Unpaid - Below Threshold",
  unpaid_not_payable:"Unpaid - Not Payable",
  unpaid_on_hold:"Unpaid - On Hold",
  unpaid_waiting:"Unpaid - Waiting for Payout",
  unrepresented: "unrepresented",
  update_albums: "update albums",
  update_first_makers: "update first makers",
  update: "update",
  upload_by: "upload by",
  upload_date: "upload date",
  upload_user: "upload user",
  uploaded_by: "uploaded by",
  uploaded_on: "uploaded on",
  uploader: "uploader",
  uploads: "uploads",
  usage_adjustment: "usage adjustment",
  usage_adjustments: "usage adjustments",
  usage_challenge_actions: "usage challenges",
  usage_challenge_resolved: "usage challenge resolved",
  usage_challenge_unmatched: "usage challenge unmatched",
  usage_challenge: "usage challenge",
  usage_date_range: "usage date range",
  usage_end_date: "usage end date",
  usage_file_deletion: "Started usage file deletion",
  usage_files: "usage files",
  usage_id: "Usage ID",
  usage_info: "usage information",
  usage_matching: "usage matching",
  usage_paid: "usage paid",
  usage_period: "usage period",
  usage_start_date: "usage start date",
  usage_year: "usage year",
  usage: "usage",
  usages_reviewed: "usages reviewed",
  usages_updated: "usages updated",
  usages: "usages",
  use_current_matched_recording: "use current matched recording",
  use_proxy_tariff: "use proxy tariff",
  use_suggested_recording: "use suggested recording",
  use: "use",
  user_action_has_been_solved: "the user action you were reviewing has been solved by another user or process",
  user_action_solved: "user action solved",
  user_actions: "user actions",
  user_id: "user id",
  user_management: "user management",
  user_name: "user name",
  user_role: "user role",
  user_roles: "user roles",
  user: "user",
  users: "users",
  valid_payee: "valid payee",
  view_details: "view details",
  view_qa: "View QA",
  view_removal_requests: "view removal requests",
  view_reprod_usages: "view reprod. usages",
  view_scope: "view scope",
  view_transactions: "view transactions",
  vpp_amounts: "VPP amounts",
  vpp_and_topup_payments: "VPP & Top Up payments",
  vpp_delta: "VPP delta",
  vpp_help_text: "Value Per Play to apply for this specific college",
  vpp_history: "VPP History",
  vpp_maker_delta: "VPP maker delta",
  vpp_maker: "VPP maker",
  vpp_override: "VPP override",
  vpp_override_available_later: "VPP override can be added after closeout is created",
  vpp_override_should_be_less_than_vpp: "The VPP cannot be overridden because the \"Net available for Closeout\" amount is less than \"VPP override x Usage\" amount. Please update the “Remaining revenue override\" first to proceed.",
  vpp_performer_delta: "VPP performer delta",
  vpp_performer: "VPP performer",
  vpp_type_help_text: "if placeholder, generated transactions will be marked as 'preview' while official will create payable transactions",
  vpp_type: "VPP type",
  vpp: "VPP",
  waiting_for_payout: "waiting for payout",
  waiting_for_sync: "waiting for synchronization",
  we_will_send_you_an_email_with_a_link: "we’ll send you an email with a link to download the report when the process is completed",
  weighted_playcount_short: "w. playcount",
  weighted_playcount: "weighted playcount",
  when: "when",
  with_candidates: "with candidates",
  with_comment: "with comment",
  with_financial_interest: "financial interest",
  withholding_tax: "withholding tax",
  witholding_rate: "withholding rate",
  witholding_taxes: "withholding taxes",
  without_candidates: "without candidates",
  word: "word",
  works_database: "works database",
  worldwide_except: "worldwide except",
  worldwide: "worldwide",
  wppt: "wppt",
  wrong_filters: "Provided filter values are not valid. Check search query syntax or contact administrator.",
  wrong_uuids_specified: "wrong uuids specified",
  wrote: "wrote",
  ww_except: "WW except",
  ww: "WW",
  year_of_fixation: "year of fixation",
  year_of_release: "year of release",
  year: "year",
  yes_cancel_editing: "yes, cancel editing",
  yes: "yes",
  yof: "yof",
  yor: "yor",
}
